import { useRouter, usePathname } from "next/navigation";
import { useMemo } from "react";
import dxPageView from "lib/ga/dxPageView";

const DEBUG = false
const debug = DEBUG ? console.log : () => {};
// debug = () => {};

const areParamsTheSame = (current, next) => {

  const currentObject = {}, nextObject = {};
  // Make a standardised object for each collection of parameters
  Array.from(current.keys()).sort().forEach((k) => {
    currentObject[k] = current.get(k);
  });

  Array.from(next.keys()).sort().forEach((k) => {
    nextObject[k] = next.get(k);
  });

  return JSON.stringify(currentObject) === JSON.stringify(nextObject);

}


export const useNextRouting = (config, basePathUrl, searchParams) => {

  debug('useNextRouting', { basePathUrl, searchParams})

  let serverUrl = '';

  if (searchParams) {
    const serverParams = new URLSearchParams()
    Object.keys(searchParams).forEach(k => {
      serverParams.append(k, searchParams[k])
    })
    serverUrl = `${basePathUrl}?${serverParams.toString()}`
  }

  const router = useRouter();
  // if we are server side just return


  // TODO - check this
  // if (!router.events)  {
  //   return config
  // };

  const asPath  = usePathname();

  // if (!asPath.includes(basePathUrl)) {
  //   return;
  // }

  const getSearchParamsFromUrl = (url) => {
    return (url || serverUrl).match(/\?(.+)/)?.[1] || "";
  };

  const getPathFromUrl = (url) => {
    return (url || serverUrl).split('?', 2)?.[0] || '';
  }

  const routingOptions = {
    // read and write only the query string to search UI
    // as we are leveraging existing stateToUrl and urlToState functions
    // which are based on the query string
    readUrl: () => {
      debug('readUrl', router.asPath, getSearchParamsFromUrl(router.asPath));
      return getSearchParamsFromUrl(router.asPath);
    },
    writeUrl: (url, { replaceUrl }) => {
      debug('writeUrl', {url, replaceUrl, basePathUrl, asPath: router.asPath});
      debug('getSearchParamsFromURl', getSearchParamsFromUrl(router.asPath));
      if (url === getSearchParamsFromUrl(asPath)) {
        debug('Same path so no write');
        return;
      }

      if (getPathFromUrl(asPath) !== basePathUrl) {
        debug('Not the right path so skipping');
        return;
      }

      // Get the current params from the url in the browser
      debug('getting path', getSearchParamsFromUrl(router.asPath));

      const intitialParams = new URLSearchParams(getSearchParamsFromUrl(router.asPath));
      const currentParams = new URLSearchParams(getSearchParamsFromUrl(router.asPath));
      debug('Current params', currentParams.toString());

      // Remove from the params anything which we are about to reset
      Array.from(currentParams.keys()).forEach((k) => {
        if (k === 'size' || k === 'current' || k.startsWith('filters') || k.startsWith('sort')) {
          currentParams.delete(k);
        }
      });

      const params = Object.fromEntries(new URLSearchParams(url).entries());
      Object.keys(params).sort().forEach((k) => {
        currentParams.set(k, params[k]);
      });

      debug('New url', currentParams.toString());

      // Check if the params have changed, we need to look at the params one by one as a string comparison doesn't work as the position of the paramater is not important.
      if (areParamsTheSame(intitialParams, currentParams)) {
        debug('current and next params are the same');
        return;
      }

      // const newParams = new URLSearchParams(params);
      const newPath = `${window.location.pathname}?${(currentParams?.toString() || '')?.replaceAll('+', '%20')}`;

      if(window.location.pathname === '/profile/dx-search') {
        dxPageView({query: (currentParams?.toString() || '')?.replaceAll('+', '%20')})
      }

      if (replaceUrl) {
          window.history.replaceState({ ...window.history.state, as: newPath, url: newPath }, '', newPath)
      } else {
        const params = new URLSearchParams(window.location.search);
        if(window.location.pathname !== '/profile/dx-search' && currentParams.get('current') !==  params.get('current')) {
          const link = document.querySelector("link[rel='canonical']");
          link.href = `${window.location.origin}${window.location.pathname}${currentParams.get('current') === null ? '' : `?current=${currentParams.get('current')}&size=${currentParams.get('size')}`}`
        }

        window.history.pushState({ ...window.history.state, as: newPath, url: newPath }, '', newPath)
      }
    },
    routeChangeHandler: (callback) => {
      const handler = (fullUrl) => {
        debug('handler', {fullUrl, asPath}, getPathFromUrl(fullUrl) );
        if (fullUrl === asPath) {
          debug('Skipping');
          return;
        }

        if (getPathFromUrl(fullUrl) !== basePathUrl) {
          debug('Not in base path so returning');
          return;
        }
        if (fullUrl.includes(basePathUrl)) {
          // callback(getSearchParamsFromUrl(fullUrl));
        }
      };

      router.events?.on("routeChangeComplete", handler);
      return () => {
        debug('Removed handler');
        router.events?.off("routeChangeComplete", handler);
      };
    }
  };
  return useMemo(() => {
    debug('Rebuild search config from memo');
    return {
      ...config,
      routingOptions
    };
  }, [router.isReady]);
};
